export default {
  EDIT: "edit",
  VIEW: "view",
};
